import { Reveal, Overline } from "./Reveal";
import { ABOUT } from "../data/content";

export const About = () => (
  <section
    id="about"
    className="relative mx-auto max-w-[1400px] px-6 py-28 lg:px-10 lg:py-40"
    data-testid="about-section"
  >
    <div className="grid gap-16 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal>
          <Overline>{ABOUT.overline}</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-4xl leading-tight tracking-tight text-white sm:text-5xl">
            {ABOUT.title}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-md text-base leading-relaxed text-zinc-400">
            {ABOUT.intro}
          </p>
        </Reveal>
      </div>

      <div className="lg:col-span-6 lg:col-start-7 lg:pt-24">
        <div className="flex flex-col gap-16">
          {ABOUT.chapters.map((c, i) => (
            <Reveal key={c.no} delay={i * 0.1}>
              <div className="border-t border-white/10 pt-6">
                <div className="flex items-baseline gap-6">
                  <span className="font-serif text-5xl italic text-gold/80">
                    {c.no}
                  </span>
                  <div>
                    <h3 className="font-serif text-2xl text-white">{c.title}</h3>
                    <p className="mt-3 max-w-md text-base leading-relaxed text-zinc-400">
                      {c.body}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
